// src/components/AddCategoriaProducto.jsx
import React from "react";
import AddCategoriaProductoForm from "./AddCategoriaProductoForm";

const AddCategoriaProducto = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="col-12">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Nueva Categoría"}
        </button>
      </div>

      {show && (
        <div className="col-md-8 offset-md-2 mb-3">
          <AddCategoriaProductoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};

export default AddCategoriaProducto;